import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export const useIsUpdateAvailable = (intervalSeconds = 60) => {
  const { pathname } = useLocation();
  const loadingRef = useRef(false);
  const etagRef = useRef("");
  const [isModified, setIsModified] = useState(false);

  const pollCurrentPath = useCallback(async () => {
    if (loadingRef.current) return;
    try {
      loadingRef.current = true;

      const response = await fetch(pathname, {
        method: "HEAD",
        headers: etagRef.current ? { "if-none-match": etagRef.current } : {},
      });

      if (!!etagRef.current && response.status !== 304) setIsModified(true);
      if (!etagRef.current) {
        etagRef.current = response.headers.get("Etag") || "none";
      }
    } catch (err) {
      console.error("Error polling content modification", err);
    } finally {
      loadingRef.current = false;
    }
  }, [pathname]);

  useEffect(() => {
    pollCurrentPath();
    const interval = setInterval(pollCurrentPath, intervalSeconds * 1000);
    return () => clearInterval(interval);
  }, [intervalSeconds, pollCurrentPath]);

  return isModified;
};
